<template>
    <v-menu ref="menu"
            v-model="menupicker"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            :content-class="menuClass"
            min-width="auto">
        <template v-slot:activator="{ on, attrs }">
            <v-text-field :value="date"
                          :label="label"
                          :rules="rules"
                          color="primary"
                          :dense="dense"
                          prepend-inner-icon="mdi-calendar"
                          :outlined="outlined"
                          :disabled="disabled"
                          v-bind="attrs"
                          :clearable="clearable"
                          readonly
                          v-on="on"
                          @click:clear="handleClear" />
        </template>
        <v-date-picker v-model="date" :name="name" :max="maxDate" :min="minDate" @input="handleInput" :locale="isRTL ? 'ar' : 'en'" />
    </v-menu>
</template>
<script>
    export default {

        props: {
            label: {
                type: String,
                default: null
            },

            value: {
                type: String,
                default: null
            },

            name: {
                type: String,
                default: null
            },

            rules: {
                type: Array,
                default: () => []
            },

            outlined: {
                type: Boolean,
                default: false
            },

            disabled: {
                type: Boolean,
                default: false
            },

            dense: {
                type: Boolean,
                default: false
            },

            clearable: {
                type: Boolean,
                default: false
            },

            maxDate: {
                type: String,
                default: null
            },

            minDate: {
                type: String,
                default: null
            }

        },

        data() {
            return {
                menupicker: false,
                date: null
            }
        },

        computed: {
            isRTL() {
                // Check if current locale is Arabic (RTL)
                return this.$i18n && this.$i18n.locale === 'ar'
            },
            menuClass() {
                return this.isRTL ? 'date-picker-menu-rtl' : 'date-picker-menu-ltr'
            }
        },

        watch: {
            value(value) {
                this.date = value != null ? value.split('T')[0] : null
            }
        },

        created() {
            //remove time since datepicker is only date without time
            this.date = this.value != null ? this.value.split('T')[0] : null
        },

        methods: {
            handleInput() {
                this.menupicker = false
                this.$emit('input', this.date)
            },

            handleClear() {
                this.$emit('input', null)
            }
        }
    }
</script>

<style>
/* Remove scoped to apply to menu content */
    .date-picker-menu-rtl .v-picker {
        transform-origin: top right !important;
    }

    .date-picker-menu-ltr .v-picker {
        transform-origin: top left !important;
    }

    .date-picker-menu-rtl.v-menu__content {
        transform-origin: top right !important;
    }

    .date-picker-menu-ltr.v-menu__content {
        transform-origin: top left !important;
    }
</style>